import React, { useState } from "react";
import { MapPin, Phone, Copy, Check, MessageCircle, ExternalLink } from "lucide-react";
import { WHATSAPP, MAPS_URL, openExternal } from "@/lib/contact";

const ADDRESS = `3D PRINT HUB STUDIO
No 35/2, Nammura Rasthe, Kodathi Road,
Gunjur Village, Kachamaranahalli,
Bengaluru, Karnataka 560087`;

function AddressCard() {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(ADDRESS);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (err) {
      console.warn("[StudioInfo] clipboard write failed:", err);
    }
  };

  return (
    <div className="border border-white/10 p-5">
      <div className="flex items-start gap-3">
        <MapPin size={18} className="text-[#FF5722] mt-0.5 shrink-0" />
        <div className="flex-1">
          <div className="label-overline mb-2">Studio address</div>
          <pre className="font-mono text-xs text-zinc-300 whitespace-pre-wrap leading-relaxed">
            {ADDRESS}
          </pre>
          <div className="text-[11px] font-mono text-zinc-500 mt-3">
            Near Gunjur Government High School · Bengaluru pickup & courier
          </div>
          <div className="flex gap-2 mt-4">
            <button
              data-testid="copy-address-button"
              onClick={onCopy}
              className="inline-flex items-center gap-1.5 px-3 h-8 border border-white/15 text-xs font-mono uppercase tracking-[0.15em] hover:border-[#FF5722] hover:text-[#FF5722] transition-colors"
            >
              {copied ? <Check size={12} /> : <Copy size={12} />}
              {copied ? "Copied" : "Copy"}
            </button>
            <a
              data-testid="open-maps-button"
              href={MAPS_URL}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => openExternal(e, MAPS_URL)}
              className="inline-flex items-center gap-1.5 px-3 h-8 border border-white/15 text-xs font-mono uppercase tracking-[0.15em] hover:border-[#FF5722] hover:text-[#FF5722] transition-colors"
            >
              <ExternalLink size={12} />
              Google Maps
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function StudioInfo() {
  return (
    <div className="space-y-5">
      <AddressCard />

      <a
        data-testid="contact-phone"
        href="tel:+918088163846"
        className="flex items-center gap-3 border border-white/10 p-5 hover:border-[#FF5722] transition-colors"
      >
        <Phone size={18} className="text-[#FF5722]" />
        <div>
          <div className="label-overline mb-1">Call studio</div>
          <div className="font-display text-xl">+91 80881 63846</div>
        </div>
      </a>

      <a
        data-testid="contact-whatsapp"
        href={WHATSAPP}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => openExternal(e, WHATSAPP)}
        className="flex items-center justify-between gap-3 bg-[#FF5722] hover:bg-[#F4511E] p-5 text-white transition-colors"
      >
        <div className="flex items-center gap-3">
          <MessageCircle size={18} />
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] opacity-70 mb-1">
              Fastest reply
            </div>
            <div className="font-display text-xl">Get Instant Quote</div>
          </div>
        </div>
        <ExternalLink size={16} />
      </a>
    </div>
  );
}
